module.exports = __webpack_public_path__ + "img/defalutIcon.e4953b9a.jpeg";